export class HttpError implements Error {
  status: number;
  error: any;
  message: string;
  name: string;
  stack: string;

  constructor(params: {
    error: any;
    status: number;
    statusText: string;
    url: string;
    headers: any;
  }) {
    // check fetch errors
    this.error = params.error;
    this.message = params.error?.message || params.statusText;
    this.status = params.status;
  }
}
